import React from 'react';
import { Radio } from '../Radio';
import { FlightCard } from './';
export const FlightSelector = ({ onSelect, selectedId, data, languageData, unitProfile, allowRemoval = false, }) => {
    const onChange = e => {
        onSelect(Number(e.target.value));
    };
    const onSelectCard = val => {
        onSelect(val);
    };
    return (React.createElement("div", { className: "flight-selector_container" },
        data.map(operation => {
            const { id, aircraftIcon, operationIcon } = operation;
            return (React.createElement("div", { key: `flight_item_${id}`, className: "flight-selector_item" },
                React.createElement(Radio, { checked: selectedId === id, onChange: onChange, value: id, className: "flight-selector_radio" }),
                React.createElement(FlightCard, { data: operation, onClick: onSelectCard, languageData: languageData, unitProfile: unitProfile, operationIcon: operationIcon, aircraftIcon: aircraftIcon })));
        }),
        allowRemoval ? (React.createElement("div", { key: `flight_item_remove`, className: "flight-selector_item" },
            React.createElement(Radio, { checked: selectedId === -1, onChange: onChange, value: -1, className: "flight-selector_radio" }),
            React.createElement(FlightCard, { data: null, onClick: onSelectCard, languageData: languageData, unitProfile: unitProfile }))) : null));
};
//# sourceMappingURL=FlightSelector.js.map